import {
    buildUserMap,
    defaultDisplayName,
    escapeRegExp,
    normalizeTaggedUserIds,
} from './mentionUtils';
import { MentionChip } from './MentionChip';

/**
 * Resalta menciones @ en texto de solo lectura.
 * @param {'chip'|'inline'} variant — `chip` e `inline` resaltan con negrita y color, sin avatar.
 */
export function MentionReadOnly({
    content = '',
    taggedUserIds: taggedUsersField = [],
    users = [],
    taggedUserDocs = [],
    getDisplayName = defaultDisplayName,
    variant = 'chip',
    inlineClassName = 'font-bold text-indigo-600 capitalize',
}) {
    const { ids, docs } = normalizeTaggedUserIds(taggedUsersField);
    const userMap = buildUserMap(users, [...taggedUserDocs, ...docs]);

    const entries = [];
    const seen = new Set();
    for (const id of ids) {
        if (seen.has(id)) continue;
        seen.add(id);
        const u = userMap.get(id);
        if (u) entries.push({ id, name: getDisplayName(u) });
    }

    entries.sort((a, b) => b.name.length - a.name.length);
    const str = String(content ?? '');
    if (!entries.length) return str;

    const alts = entries.map((n) => escapeRegExp(`@${n.name}`)).join('|');
    const re = new RegExp(`(${alts})(?=$|\\s|\\n)`, 'g');
    const nodes = [];
    let last = 0;
    let m;
    let k = 0;

    while ((m = re.exec(str)) !== null) {
        if (m.index > last) {
            nodes.push(<span key={`t-${k++}`}>{str.slice(last, m.index)}</span>);
        }

        if (variant === 'inline') {
            nodes.push(
                <span key={`m-${k++}`} className={inlineClassName}>
                    {m[1]}
                </span>,
            );
        } else {
            nodes.push(
                <MentionChip
                    key={`m-${k++}`}
                    label={m[1]}
                />,
            );
        }
        last = m.index + m[1].length;
    }

    if (last < str.length) {
        nodes.push(<span key={`t-${k++}`}>{str.slice(last)}</span>);
    }

    return nodes.length ? nodes : str;
}

/** Alias de compatibilidad con notas de estudiante. */
export function renderMentionsReadOnly(content, taggedUsersField, users) {
    return (
        <MentionReadOnly
            content={content}
            taggedUserIds={taggedUsersField}
            users={users}
        />
    );
}
